import React from 'react'
import FrontPageReviews from './FrontPageReviews'
import Group from 'components/utils/Group'
import GoogleTrustIndicator from 'home/components/TrustIndicatorSection/GoogleTrustIndicator'
import StatisticTrustIndicator from 'home/components/TrustIndicatorSection/StatisticTrustIndicator'
import Heading from 'components/Luxkit/Typography/Heading'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'

/*
 Sadly needed as otherwise the width is calculated breaking out of the layout container
*/
const ReviewSection = styled(Group)`
  ${mediaQueryUp.tablet} {
    width: 80%;
  }
`

/*
 Sadly needed as otherwise the width is calculated breaking out of the layout container
*/
const TrustIndicators = styled(Group)`
  ${mediaQueryUp.tablet} {
    width: 20%;
  }
`

function FrontPageReviewVariant() {
  return (
    <Group direction="vertical-reverse" tabletDirection="horizontal" tabletGap={48} gap={16}>
      <TrustIndicators direction="horizontal" tabletDirection="vertical" gap={24} verticalAlign="center" horizontalAlign="center">
        <GoogleTrustIndicator />
        <StatisticTrustIndicator />
      </TrustIndicators>
      <ReviewSection direction="vertical" gap={16} tabletGap={32}>
        <Heading variant="heading3">Hear from our happy customers</Heading>
        <FrontPageReviews/>
      </ReviewSection>
    </Group>
  )
}

export default FrontPageReviewVariant
